import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { usePlanEntitlement } from '../hooks/usePlanEntitlement';
import { useCheckout } from '../hooks/useCheckout';
import { PlanOptionCards } from '../components/Billing/PlanOptionCards';
import { trackEvent } from '../utils/visitorTracking';
export function PaymentPage() {
  const {
    user
  } = useAuth();
  const navigate = useNavigate();
  const {
    planId,
    planLabel,
    accessLabel,
    loading
  } = usePlanEntitlement();
  const {
    onCheckout,
    pendingPlan
  } = useCheckout('payment_page');
  // Landing on this route IS the pricing view. Ref guard so Strict Mode's
  // double-invoked effect (and any re-render) logs exactly one view.
  const viewTracked = useRef(false);
  useEffect(() => {
    if (!user || viewTracked.current) return;
    viewTracked.current = true;
    void trackEvent('pricing_viewed', {
      location: 'payment_page'
    });
    void trackEvent('premium_view', {
      location: 'payment_page'
    });
  }, [user]);
  if (!user) {
    navigate('/login');
    return null;
  }
  return <div className="min-h-screen w-full bg-[#050505]" data-id="element-9230" data-mp="2nyyklsbwk2fl">
      <div className="mx-auto w-full max-w-5xl px-6 py-10" data-id="element-9231" data-mp="32v62glzu8rrp">
        <button type="button" onClick={() => navigate('/dashboard')} className="flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-widest text-gray-400 transition-colors duration-150 ease-out hover:text-white" data-id="element-9232" data-mp="2xv1j8o7jpixs">
          <ArrowLeft size={16} data-id="element-9233" data-mp="36vg8tzrjlk73" />
          Back to dashboard
        </button>

        <header className="mt-10 mb-8" data-id="element-9234" data-mp="3ljb1xh9gpqkp">
          <p className="font-mono text-[10px] font-bold uppercase tracking-[0.2em] text-[#FF0000]" data-id="element-9235" data-mp="3lmgpgs2g0keb">
            Clearance levels
          </p>
          <h1 className="mt-2 text-3xl font-black uppercase tracking-tight text-white sm:text-4xl" data-id="element-9236" data-mp="3ukivxn4y458z">
            Choose your access
          </h1>
          <p className="mt-3 font-mono text-xs text-gray-400" data-id="element-9237" data-mp="3qhmcxvbhu74i">
            {loading ? 'Verifying your current clearance…' : `Current plan: ${planLabel} — ${accessLabel.toLowerCase()}.`}
          </p>
        </header>

        <PlanOptionCards onCheckout={plan => void onCheckout(plan)} pendingPlan={pendingPlan} currentPlanId={planId} onStartFree={() => navigate('/upload')} data-id="element-9238" data-mp="bffet764ksq7" />
      </div>
    </div>;
}